import { useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { FORMAT_TEXT_COMMAND } from 'lexical';
import { UnderlineAction } from '../../molecules/underline-action';
import { useToolbarState } from '../../providers/toolbar-provider';

export const Underline = () => {
  const [editor] = useLexicalComposerContext();
  const { isUnderline } = useToolbarState(['isUnderline']);

  const onUnderlineSelect = useCallback(() => {
    editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline');
  }, [editor]);

  return <UnderlineAction onClick={onUnderlineSelect} isActive={isUnderline} aria-label='Format Underline' />;
};

Underline.displayName = 'Underline';
